import axios from 'axios';

export const getTokenInURL = string => {
  const queryString = string.split('?')[1];
  if (!queryString) return null;

  const params = new URLSearchParams(queryString);
  return params.get('token');
};

const { API_URL, API_URL_V2, MY_INVOICES_URL } = process.env;

export const http = axios.create({
  baseURL: API_URL,
  headers: {
    'Accept-Language': 'pt_BR'
  }
});

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token');
    const tokenType = localStorage.getItem('token_type') || 'Bearer';
    if (token) config.headers.common.Authorization = `${tokenType} ${token}`;
    config.headers.common['Content-Type'] = 'application/json';
    return config;
  },
  error => Promise.reject(error)
);

export const httpV2 = axios.create({
  baseURL: API_URL_V2,
  headers: {
    'Accept-Language': 'pt_BR'
  }
});

httpV2.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token');
    const tokenType = localStorage.getItem('token_type') || 'Bearer';
    if (token) config.headers.common.Authorization = `${tokenType} ${token}`;
    config.headers.common['Content-Type'] = 'application/json';
    return config;
  },
  error => Promise.reject(error)
);

export const myInvoicesGet = axios.create({
  baseURL: MY_INVOICES_URL,
  headers: {
    'Accept-Language': 'pt_BR'
  }
});

myInvoicesGet.interceptors.request.use(
  config => {
    config.headers.common['Clippfacil-Token'] = localStorage.getItem(
      'access_token'
    );
    config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
    return config;
  },
  error => Promise.reject(error)
);

export const myInvoicesPost = axios.create({
  baseURL: MY_INVOICES_URL,
  headers: {
    'Accept-Language': 'pt_BR'
  }
});

myInvoicesPost.interceptors.request.use(
  config => {
    config.headers.common['Clippfacil-Token'] = localStorage.getItem(
      'access_token'
    );
    config.headers.common['Content-Type'] = 'application/json';
    return config;
  },
  error => Promise.reject(error)
);

export const httpLogin = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt_BR'
  }
});

export const httpLoginV2 = axios.create({
  baseURL: API_URL_V2,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt_BR'
  }
});



// WEBPACK FOOTER //
// ./src/public/api/backend.js